export class LicenseBundleResponse {
  licenseBundleId: string;
  licenseKey: string;
  offline: number;
  offlineLicenseKey?: string;
  offlineLicenseKeyExpirationTime: Date | null;
  activationTime: Date;

  constructor(licenseBundle: any = {}) {
    this.licenseBundleId = licenseBundle.licenseBundleId;
    this.licenseKey = licenseBundle.licenseKey;
    this.offline = licenseBundle.offlineActivation;
    this.offlineLicenseKey = licenseBundle.offlineLicenseKey;
    this.offlineLicenseKeyExpirationTime = licenseBundle.offlineLicenseKeyExpirationTime;
    this.activationTime = licenseBundle.activationTime;
  }
}
